import { useState, useCallback } from 'react';

export type AgencyRequiredFieldProps = {
  code_required: boolean;
  division_required: boolean;
};

export const useAddRepresentativesAgencyRequiredField = () => {
  const [agencyRequiredField, setAgencyRequiredField] = useState<AgencyRequiredFieldProps>({
    code_required: false,
    division_required: false,
  });

  const handleAgencyRequiredField = useCallback((value: AgencyRequiredFieldProps) => {
    setAgencyRequiredField(value);
  }, []);

  return { agencyRequiredField, handleAgencyRequiredField };
};
